import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var CancelOrderIA = function CancelOrderIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4agNLN",
    defaultMessage: [{
      "type": 0,
      "value": "Orders can be cancelled under specific circumstances before they reach certain processing stages. You can see more information about why a specific order has been cancelled by going to the "
    }, {
      "children": [{
        "type": 0,
        "value": "order details page"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " and looking at the timeline for that order. Here’s an overview of when orders may be cancelled."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8z47MZ",
    defaultMessage: [{
      "type": 0,
      "value": "First, you can cancel unfulfilled orders if you can’t fulfil them for specific reasons, such as inventory issues or exclusivity conflicts."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4ZAq1R",
    defaultMessage: [{
      "type": 0,
      "value": "For retailers, there’s a 24-hour window to cancel new orders, as long the order has not been accepted yet. Beyond this window, or once you have accepted an order, cancellation requests will be sent to you, and you’ll have the ability to accept or reject the request."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7c/yYT",
    defaultMessage: [{
      "type": 0,
      "value": "Lastly, orders can be automatically cancelled by Faire if there are long delays in fulfilment. This can happen if you don’t enter an expected shipment date for a new orders within 30 days, or if you don’t provide tracking information for an accepted order within 30 days of the specified ship date."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrders(),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};